import AvailableFiches from './AvailableFiches.vue'
import CustomerPreOrders from './CustomerPreOrders.vue'
import PreOrderProcessing from './PreOrderProcessing.vue'
import Create from './Create.vue'
import Edit from './Edit.vue'
import Base from './Base.vue'

export default {
    AvailableFiches,
    CustomerPreOrders,
    PreOrderProcessing,
    Create,
    Edit,
    Base
}


// WEBPACK FOOTER //
// ./src/views/admin/preOrders/index.js